<form novalidate (ngSubmit)="goNext()" [formGroup]="previousEmploymentInfoForm" [ngClass]='{"h-100": !isBuyNow && !isLegacyCreditApp}'>
  <div class="row m-0 credit-app-body" [ngClass]='{"noshadow previous-employment-info-buynow": isBuyNow || isLegacyCreditApp, "previous-employment-info pl-4 pr-4": !isBuyNow && !isLegacyCreditApp}'>
    <div class="col-12 scrollDiv">
      <div class="row m-0">
        <div class="col-12 col-md-6  col-xl-4 px-0 pr-md-2 order-1" [ngClass]="{'bn-empl-wide': isBuyNow || isLegacyCreditApp }">
          <label>{{ prevEmploymentInfoConfigData?.PreviousEmploymentStatusLabel }}</label>
          <select id="prev_employment_status" class="form-control   gradient" formControlName="PrevEmploymentStatus"
            [ngClass]="{'error': !previousEmploymentInfoForm.get('PrevEmploymentStatus').valid &&
                                  (formSubmitAttempt ||
                                    (previousEmploymentInfoForm.get('PrevEmploymentStatus').touched
                                      || previousEmploymentInfoForm.get('PrevEmploymentStatus').dirty))}">
            <option value="" [selected]="previousEmploymentInfoForm.get('PrevEmploymentStatus').value === ''">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let employmentStatusType of employmentStatusTypes" [value]="employmentStatusType.Value"
              [selected]="employmentStatusType.Value === previousEmploymentInfoForm.get('PrevEmploymentStatus').value">
              {{ employmentStatusType?.Description }}
            </option>
          </select>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block"
              *ngIf="!previousEmploymentInfoForm.get('PrevEmploymentStatus').valid &&
                        (formSubmitAttempt ||
                          (previousEmploymentInfoForm.get('PrevEmploymentStatus').touched
                            || previousEmploymentInfoForm.get('PrevEmploymentStatus').dirty))">
              <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmploymentStatus').errors?.required">
                {{ prevEmploymentInfoConfigData?.PreviousEmploymentStatusRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <!-- <div class="d-none d-md-block d-lg-none col-md-6" *ngIf="isCustomerRetired">
        </div> -->
        <div class="col-12 col-md-6  col-xl-4 px-0 pl-md-2 order-2" *ngIf="!isCustomerRetired" [ngClass]="{'bn-empl-wide': isBuyNow || isLegacyCreditApp }">
          <label>{{ prevEmploymentInfoConfigData?.PreviousEmploymentTypeLabel }}</label>
          <select id="prev_employment_type"
                  class="form-control   gradient"
                  formControlName="PrevEmploymentType"
                  [ngClass]="{'error': !previousEmploymentInfoForm.get('PrevEmploymentType').valid &&
                                          (formSubmitAttempt ||
                                            (previousEmploymentInfoForm.get('PrevEmploymentType').touched
                                              || previousEmploymentInfoForm.get('PrevEmploymentType').dirty))}">
            <option value="" [selected]="previousEmploymentInfoForm.get('PrevEmploymentType').value === ''">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let employmentType of employmentTypes" [value]="employmentType.Value"
              [selected]="employmentType.Value === previousEmploymentInfoForm.get('PrevEmploymentType').value">
              {{ employmentType?.Description }}
            </option>
          </select>

          <div class="form-validator_error">
            <span class="invalid-feedback d-block"
                  *ngIf="!!previousEmploymentInfoForm.get('PrevEmploymentType')?.errors &&
                            (formSubmitAttempt ||
                              (previousEmploymentInfoForm.get('PrevEmploymentType').touched
                                || previousEmploymentInfoForm.get('PrevEmploymentType').dirty))">
              <ng-container *ngIf="previousEmploymentInfoForm.get('PrevEmploymentType')?.errors">
                {{ prevEmploymentInfoConfigData?.PreviousEmploymentTypeInvalid}}
              </ng-container>
            </span>
          </div>
        </div>
        <div formGroupName="PrevRetiredDurationGroup" *ngIf="isCustomerRetired" class="col-12 col-lg-6 px-0 order-7" [ngClass]="{'group-padding': !isBuyNow && !isLegacyCreditApp}">
          <div class="row m-0 p-0" >
              <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-md-5 col-lg-6 px-0 pr-md-2 {{isLegacyCreditApp && isMobile() ? 'pr-sm-0' : 'pr-sm-7'}}" [ngClass]="{'bn-empl-others': isBuyNow || isLegacyCreditApp}">
                  <label class="d-block nowrap">Total Years Retired</label>
                  <select id="prev_total_years_retired" class="form-control w-100 w-sm-75 gradient" formControlName="PrevTotalYearsRetired" [ngClass]="{'error': previousEmploymentInfoForm.get('PrevRetiredDurationGroup').errors ||
                                                            (!previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').valid &&
                                                            (formSubmitAttempt || (previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').touched
                                                              || previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').dirty)))}">
                    <option [selected]="previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').value === ''
                                                            || previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').value === null">
                      {{ creditAppConfigData?.SelectsDefaultLabel }}
                    </option>
                    <option *ngFor="let yearOnJobType of yearsOnJobType" [value]="yearOnJobType.Value"
                      [selected]="yearOnJobType.Value === previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').value">
                      {{ yearOnJobType?.Description }}
                    </option>
                  </select>
                  <div class="form-validator_error">
                    <span class="invalid-feedback d-block" *ngIf="previousEmploymentInfoForm.get('PrevRetiredDurationGroup').errors ||
                                                (!previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').valid &&
                                                (formSubmitAttempt ||
                                                  (previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').touched
                                                    || previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').dirty)))">
                      <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').errors?.required; else secondRetired">
                        Total Years Retired is required
                      </ng-container>
                      <ng-template #secondRetired>
                          <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevRetiredDurationGroup').errors?.invalidselection">
                              {{ prevEmploymentInfoConfigData?.TotalYrsZeroValidation }}
                            </ng-container>
                      </ng-template>
                    </span>
                  </div>
              </div>
              <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-md-5 col-lg-6 px-0 pl-md-2 {{isLegacyCreditApp && isMobile() ? 'pl-sm-0' : 'pl-sm-7'}}" [ngClass]="{'bn-empl-others': isBuyNow || isLegacyCreditApp}">
                <label  class="d-block nowrap">Total Months Retired</label>
                <select id="prev_total_months_retired" class="form-control w-100 w-sm-75 gradient" formControlName="PrevTotalMonthsRetired" [ngClass]="{'error': previousEmploymentInfoForm.get('PrevRetiredDurationGroup').errors ||
                                                          (!previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').valid &&
                                                          (formSubmitAttempt || (previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').touched
                                                            || previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').dirty)))}">
                  <option [selected]="previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').value === ''
                                                          || previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').value === null">
                    {{ creditAppConfigData?.SelectsDefaultLabel }}
                  </option>
                  <option *ngFor="let monthOnJobType of monthsOnJobType" [value]="monthOnJobType.Value"
                    [selected]="monthOnJobType.Value === previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').value">
                    {{ monthOnJobType?.Description }}
                  </option>
                </select>
                <div class="form-validator_error">
                  <span class="invalid-feedback d-block" *ngIf="previousEmploymentInfoForm.get('PrevRetiredDurationGroup').errors ||
                                              (!previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').valid &&
                                              (formSubmitAttempt || (previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').touched
                                                || previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').dirty)))">
                    <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').errors?.required;else second">
                      Total Months Retired is required
                    </ng-container>
                    <ng-template #second>
                        <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevRetiredDurationGroup').errors?.invalidselection">
                            {{ prevEmploymentInfoConfigData?.TotalMnthsZeroValidation }}
                        </ng-container>
                    </ng-template>
                  </span>
                </div>
              </div>
          </div>
        </div>

        <div class="break col-12 order-3"></div>
        <div class="col-12 col-md-6  col-xl-4 px-0 pr-md-2 order-3" *ngIf="!isCustomerRetired" [ngClass]="{'bn-empl-wide emp-name': isBuyNow || isLegacyCreditApp }">
            <label>{{ prevEmploymentInfoConfigData?.PreviousEmployerNameLabel }}</label>
            <input id="previous_employer_name"
                    class="form-control pr-5" type="text"
                    formControlName="PrevEmployerName"
                    maxlength="25"
                    [ngClass]="{'error': !previousEmploymentInfoForm.get('PrevEmployerName').valid &&
                                            (previousEmploymentInfoForm.get('PrevEmployerName').touched ||
                                              previousEmploymentInfoForm.get('PrevEmployerName').dirty ||
                                                (formSubmitAttempt && !prevEmployerNameCleared))}" />
            <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x"
                  *ngIf="!previousEmploymentInfoForm.get('PrevEmployerName').valid &&
                            (previousEmploymentInfoForm.get('PrevEmployerName').touched ||
                              previousEmploymentInfoForm.get('PrevEmployerName').dirty ||
                                (formSubmitAttempt && !prevEmployerNameCleared))"
              (click)="clearValidations(previousEmploymentInfoForm.get('PrevEmployerName'))" aria-label="Clear previous employer name"
              (keyup)="$event?.keyCode ===  13 ? clearValidations(previousEmploymentInfoForm.get('PrevEmployerName')) : null" tabindex="3">

            </span>
            <div class="form-validator_error">
              <span class="invalid-feedback d-block"
                    *ngIf="!previousEmploymentInfoForm.get('PrevEmployerName').valid &&
                              (previousEmploymentInfoForm.get('PrevEmployerName').touched ||
                                previousEmploymentInfoForm.get('PrevEmployerName').dirty ||
                                  (formSubmitAttempt && !prevEmployerNameCleared))">
                <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmployerName').errors?.required; else second">
                  {{ prevEmploymentInfoConfigData?.PreviousEmployerNameRequired }}
                </ng-container>
                <ng-template #second>
                    <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmployerName').errors?.pattern">
                        {{prevEmploymentInfoConfigData?.PreviousEmployerNameInvalid}}
                      </ng-container>
                </ng-template>
              </span>
            </div>
          </div>
          <div class="col-12 col-md-6  col-xl-4 px-0 pl-md-2 order-4" *ngIf="!isCustomerRetired" [ngClass]="{'bn-empl-wide': isBuyNow || isLegacyCreditApp }">
            <label>{{ prevEmploymentInfoConfigData?.PreviousJobTitleLabel }}</label>
            <input id="previous_job_title"
                    class="form-control  pr-5" type="text"
                    maxlength="20"
                    formControlName="PrevJobTitle"
                    [ngClass]="{'error': !previousEmploymentInfoForm.get('PrevJobTitle').valid &&
                                            (previousEmploymentInfoForm.get('PrevJobTitle').touched ||
                                              previousEmploymentInfoForm.get('PrevJobTitle').dirty ||
                                                (formSubmitAttempt && !prevJobTitleCleared))}" />
            <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x"
                  *ngIf="!previousEmploymentInfoForm.get('PrevJobTitle').valid &&
                            (previousEmploymentInfoForm.get('PrevJobTitle').touched ||
                              previousEmploymentInfoForm.get('PrevJobTitle').dirty ||
                                (formSubmitAttempt && !prevJobTitleCleared))"
                  (click)="clearValidations(previousEmploymentInfoForm.get('PrevJobTitle'))" aria-label="Clear previous job title"
                  (keyup)="$event?.keyCode ===  13 ? clearValidations(previousEmploymentInfoForm.get('PrevJobTitle')) : null">

            </span>
            <div class="form-validator_error">
              <span class="invalid-feedback d-block"
                    *ngIf="!previousEmploymentInfoForm.get('PrevJobTitle').valid &&
                              (previousEmploymentInfoForm.get('PrevJobTitle').touched ||
                                previousEmploymentInfoForm.get('PrevJobTitle').dirty ||
                                  (formSubmitAttempt && !prevJobTitleCleared))">
                <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevJobTitle').errors?.required; else second">
                  {{ prevEmploymentInfoConfigData?.PreviousJobTitleRequired }}
                </ng-container>
                <ng-template #second>
                  <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevJobTitle').errors?.pattern">
                      {{prevEmploymentInfoConfigData?.PreviousJobTitleInvalid}}
                    </ng-container>
                </ng-template>
              </span>
            </div>
        </div>
        <div class="break col-12 order-5"></div>
        <div class="col-12 col-lg-3 px-0 pr-md-2 order-5" *ngIf="!isCustomerRetired"[ngClass]="{'col-md-6 bn-empl-phone-wide emp-phone': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp}">
          <label>{{ prevEmploymentInfoConfigData?.PreviousEmployerPhoneNumberLabel }}</label>
          <input id="prev_employer_phone" class="form-control w-100 pr-6" type="text" formControlName="PrevEmployerPhone"
                  [dtTextMask]="{ mask: phoneMask, guide:true }"
                  placeholder="(___)___-____"
                  [ngClass]="{'error': !previousEmploymentInfoForm.get('PrevEmployerPhone').valid &&
                                          (previousEmploymentInfoForm.get('PrevEmployerPhone').touched ||
                                            previousEmploymentInfoForm.get('PrevEmployerPhone').dirty ||
                                              (formSubmitAttempt && !prevEmployerPhoneCleared)) }" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x"
                *ngIf="!previousEmploymentInfoForm.get('PrevEmployerPhone').valid &&
                          (previousEmploymentInfoForm.get('PrevEmployerPhone').touched ||
                            previousEmploymentInfoForm.get('PrevEmployerPhone').dirty ||
                              (formSubmitAttempt && !prevEmployerPhoneCleared))"
            (click)="clearValidations(previousEmploymentInfoForm.get('PrevEmployerPhone'))" aria-label="Clear previous employer phone"
            (keyup)="$event?.keyCode ===  13 ? clearValidations(previousEmploymentInfoForm.get('PrevEmployerPhone')) : null" tabindex="3">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block"
                  *ngIf="!previousEmploymentInfoForm.get('PrevEmployerPhone').valid &&
                            (previousEmploymentInfoForm.get('PrevEmployerPhone').touched ||
                              previousEmploymentInfoForm.get('PrevEmployerPhone').dirty ||
                                (formSubmitAttempt && !prevEmployerPhoneCleared))">
              <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmployerPhone').errors?.required; else second">
                {{ prevEmploymentInfoConfigData?.PreviousEmployerPhoneNumberRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container
                  *ngIf="!previousEmploymentInfoForm.get('PrevEmployerPhone').valid"
                >
                  {{ prevEmploymentInfoConfigData?.PreviousEmployerPhoneNumberInvalid }}
                </ng-container>
              </ng-template>
            </span>
          </div>
        </div>

        <div class="d-none d-md-block d-lg-none col-md-7 order-6" *ngIf="!isCustomerRetired">

        </div>


        <div formGroupName="PrevEmployerDurationGroup" class="col-12 col-lg-6 px-0 pl-lg-2 order-7" *ngIf="!isCustomerRetired" [ngClass]='{"group-padding":!isBuyNow && !isLegacyCreditApp}'>
            <div class="row m-0 p-0">
                <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-lg-6 col-xl-6 px-0 pr-md-2 {{isLegacyCreditApp && isMobile() ? 'pr-sm-0' : 'pr-sm-7'}}" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp }">
                  <label class="d-block nowrap">{{ prevEmploymentInfoConfigData?.PreviousTotalYearsAtJobLabel }}</label>
                  <select id="prev_total_years"
                          class="form-control w-100 w-sm-100 gradient"
                          formControlName="PrevTotalYears"
                          [ngClass]="{'error': previousEmploymentInfoForm.get('PrevEmployerDurationGroup').errors ||
                                                  (!previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').valid &&
                                                  (formSubmitAttempt ||
                                                    (previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').touched ||
                                                      previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').dirty)))}">
                    <option value="" [selected]="previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').value === ''
                                                                || previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').value === null">
                      {{ creditAppConfigData?.SelectsDefaultLabel }}
                    </option>
                    <option *ngFor="let yearOnJobType of yearsOnJobType" [value]="yearOnJobType.Value"
                      [selected]="yearOnJobType.Value === previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').value">
                      {{ yearOnJobType?.Description }}
                    </option>
                  </select>
                  <div class="form-validator_error">
                    <span class="invalid-feedback d-block"
                          *ngIf="previousEmploymentInfoForm.get('PrevEmployerDurationGroup').errors ||
                                    (!previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').valid &&
                                    (formSubmitAttempt ||
                                      (previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').touched
                                        || previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').dirty)))">
                      <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').errors?.required; else second">
                        {{ prevEmploymentInfoConfigData?.PreviousTotalYearsAtJobRequired }}
                      </ng-container>
                      <ng-template #second>
                          <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmployerDurationGroup').errors?.invalidselection">
                              {{ prevEmploymentInfoConfigData?.TotalYrsZeroValidation }}
                            </ng-container>
                      </ng-template>
                    </span>
                  </div>
                </div>
                <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-lg-6 col-xl-6 px-0 pl-md-2 {{isLegacyCreditApp && isMobile() ? 'pl-sm-0' : 'pl-sm-7'}}" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp }">
                    <label class="d-block nowrap">{{ prevEmploymentInfoConfigData?.PreviousTotalMonthsAtJobLabel }}</label>
                    <select id="prev_total_months"
                            class="form-control w-100 w-sm-100 gradient"
                            formControlName="PrevTotalMonths"
                            [ngClass]="{'error': previousEmploymentInfoForm.get('PrevEmployerDurationGroup').errors ||
                                                    (!previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').valid &&
                                                    (formSubmitAttempt ||
                                                      (previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').touched
                                                        || previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').dirty)))}">
                            <option value="" [selected]="previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').value === ''
                                                                      || previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').value === null">
                              {{ creditAppConfigData?.SelectsDefaultLabel }}
                            </option>
                            <option *ngFor="let monthOnJobType of monthsOnJobType" [value]="monthOnJobType.Value"
                              [selected]="monthOnJobType.Value === previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').value">
                              {{ monthOnJobType?.Description }}
                            </option>
                    </select>
                    <div class="form-validator_error">
                        <span class="invalid-feedback d-block"
                              *ngIf="previousEmploymentInfoForm.get('PrevEmployerDurationGroup').errors ||
                                        (!previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').valid &&
                                        (formSubmitAttempt ||
                                          (previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').touched
                                            || previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').dirty)))">
                          <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').errors?.required; else second">
                            {{ prevEmploymentInfoConfigData?.PreviousTotalMonthsAtJobRequired }}
                          </ng-container>
                          <ng-template #second>
                              <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevEmployerDurationGroup').errors?.invalidselection">
                                  {{ prevEmploymentInfoConfigData?.TotalMnthsZeroValidation }}
                                </ng-container>
                          </ng-template>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="break col-12 order-9"></div>
      <div class="d-none d-lg-block col-lg-3 order-8" *ngIf="!isCustomerRetired">
      </div>
      <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col-6'}} col-lg-3 px-0 pr-md-2 {{isLegacyCreditApp && isMobile() ? 'pr-sm-0' : 'pr-sm-7'}} order-9" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow || isLegacyCreditApp, 'col-md-5': !isBuyNow && !isLegacyCreditApp }">
          <label class="d-block nowrap">{{ prevEmploymentInfoConfigData?.PreviousGrossSalaryLabel }}</label>
          <div class="dollar-symbol w-sm-75">
            <input id="prev_gross_salary"
                    class="form-control w-100"
                    type="text" formControlName="PrevGrossSalary"
                    [dtTextMask]="{ mask: numberMask, guide:false }"
                    [ngClass]="{'error': !previousEmploymentInfoForm.get('PrevGrossSalary').valid &&
                                      (previousEmploymentInfoForm.get('PrevGrossSalary').touched ||
                                        previousEmploymentInfoForm.get('PrevGrossSalary').dirty ||
                                          (formSubmitAttempt && !prevGrossSalaryCleared)) ,
                                        'pl-5 pr-5': !isMobile()}"
                    maxlength="7"/>
          </div>
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 gross-salary-error-x error-x"
            *ngIf="!previousEmploymentInfoForm.get('PrevGrossSalary').valid &&
                      (previousEmploymentInfoForm.get('PrevGrossSalary').touched ||
                        previousEmploymentInfoForm.get('PrevGrossSalary').dirty ||
                          (formSubmitAttempt && !prevGrossSalaryCleared))"
            (click)="clearValidations(previousEmploymentInfoForm.get('PrevGrossSalary'))" aria-label="Clear previous gross salary"
            (keyup)="$event?.keyCode ===  13 ? clearValidations(previousEmploymentInfoForm.get('PrevGrossSalary')) : null" tabindex="3">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block"
                  *ngIf="!previousEmploymentInfoForm.get('PrevGrossSalary').valid &&
                            (previousEmploymentInfoForm.get('PrevGrossSalary').touched ||
                              previousEmploymentInfoForm.get('PrevGrossSalary').dirty ||
                                (formSubmitAttempt && !prevGrossSalaryCleared))">
              <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevGrossSalary').errors?.required">
                {{ prevEmploymentInfoConfigData?.PreviousGrossSalaryRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <!--<div class="col-6 col-lg-3 px-0 pl-md-2 pl-sm-7 order-10" [ngClass]="{'col-md-6 bn-empl-others': isBuyNow, 'col-md-5': !isBuyNow }">
          <label class="d-block nowrap">{{ prevEmploymentInfoConfigData?.PreviousIncomeFrequencyLabel }}</label>
          <select id="prev_income_frequency" class="form-control w-100 w-sm-75 gradient" formControlName="PrevIncomeFrequency"
                  [ngClass]="{'error': !previousEmploymentInfoForm.get('PrevIncomeFrequency').valid &&
                                          (formSubmitAttempt ||
                                            (previousEmploymentInfoForm.get('PrevIncomeFrequency').touched
                                              || previousEmploymentInfoForm.get('PrevIncomeFrequency').dirty))}">
            <option value="" [selected]="previousEmploymentInfoForm.get('PrevIncomeFrequency').value === ''">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let incomePeriodInterval of incomePeriodIntervalType" [value]="incomePeriodInterval.Value"
              [selected]="incomePeriodInterval.Value === previousEmploymentInfoForm.get('PrevIncomeFrequency').value">
              {{ incomePeriodInterval?.Description }}
            </option>
          </select>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block"
                  *ngIf="!previousEmploymentInfoForm.get('PrevIncomeFrequency').valid &&
                            (formSubmitAttempt ||
                              (previousEmploymentInfoForm.get('PrevIncomeFrequency').touched
                                || previousEmploymentInfoForm.get('PrevIncomeFrequency').dirty))">
              <ng-container *ngIf="!!previousEmploymentInfoForm.get('PrevIncomeFrequency').errors?.required">
                {{ prevEmploymentInfoConfigData?.PreviousIncomeFrequencyRequired }}
              </ng-container>
            </span>
          </div>
        </div>-->
      </div>
    </div>
  </div>

</form>





<div class="credit-app-cta-section">
  <div class="row m-0 w-100 cta-section">
    <div class="col-12 p-0 d-flex cta-col cta-alignment m-0">
      <button
        id="back_cta"
        type="button"
        class="secondary-cta mr-auto"
        [disabled]="isSaving"
        (click)="goBack()"
      >
        {{  prevEmploymentInfoConfigData?.BackCta  }}
      </button>
      <button
        id="next_cta"
        class="primary-cta ml-auto"
        [disabled]="!previousEmploymentInfoForm.valid || isSaving"
        (click)="goNext()"
      >
        {{prevEmploymentInfoConfigData?.NextCta }}
      </button>
    </div>
  </div>
</div>
